import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-tc',
  templateUrl: './tc.component.html',
  styleUrls: ['./tc.component.scss'],
})
export class TcComponent implements OnInit {
  title = 'cheggout-terms-conditions';
  bankName: string = '';
  storeid: number = 0;
  result: any;
  isloader: boolean = false;
  dataLen: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private common: HttpService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.bankName = params['bank'];
      this.storeid = params['storeid'];
      let data = {
        storeId: params['storeid'],
        offerId: params['offerid'],
        language: params['language'],
        bankName: params['bank'],
      };
      if (this.storeid && this.bankName) {
        this.isloader = true;
        this.common.getTermsAndConditions(data).subscribe((res: any) => {
          this.result = res[0];
          console.log(this.result, 'Test result');
          this.dataLen = res.length;
          this.isloader = false;
        });
      }
    });
  }
}
